import React, { useState } from "react";

import { Chip, Paper, Switch } from "@mui/material";
import { ICookieConsentDialogStrings } from "./CookieConsentDialog";
import BNBox from "../BNBox/BNBox";

interface Props {
  header: string;
  description: string;
  force?: boolean;
  chandleCheckedChange: (arg: boolean) => void;
  strings: ICookieConsentDialogStrings;
  checked: boolean;
  dataUit?: string;
}

const CookieConsentSwitch: React.FC<Props> = (props) => {
  const [isChecked, setIsChecked] = useState<boolean>(props.checked);
  return (
    <>
      <Paper
        sx={{
          backgroundColor: "secondary.lighter",
          fontSize: "1.4rem",
          mb: 1,
          pl: 2,
          pt: 0,
          pb: 2,
          pr: 1,
        }}
      >
        <BNBox
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
            paddingBottom: 1,
          }}
        >
          <BNBox sx={{ fontSize: "2rem", fontWeight: "bold", pt: 2 }}>{props.header}</BNBox>
          {!props.force && (
            <BNBox sx={{ mt: 1 }}>
              <Switch
                onChange={(event: any) => {
                  props.chandleCheckedChange(event.target.checked);
                  setIsChecked(event.target.checked);
                }}
                checked={isChecked}
                slotProps={
                  {
                    input: {
                      ["data-uit"]: props.dataUit,
                    },
                  } as any
                }
              />
            </BNBox>
          )}
          {props.force && (
            <Chip
              sx={{
                mt: 2,
                height: "2rem",
                fontSize: "1.2rem",
                px: 1,
              }}
              label={props?.strings?.cookieConsentDialog_SwitchAlwaysOn}
              color="success"
            />
          )}
        </BNBox>
        <div>{props.description}</div>
      </Paper>
    </>
  );
};
export default CookieConsentSwitch;
